export default {
	cartoDB_Light: {
		key: 'cartoDB_Light',
		thumbnail: 'cartoDB_VoyagerNoLabels',
		name: 'Base',
		type: 'wmts',
		options: {
			url: 'https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png',
		},
	},
	cartoDB_LightNoLabels: {
		key: 'cartoDB_LightNoLabels',
		thumbnail: 'cartoDB_VoyagerNoLabels',
		name: 'No labels',
		type: 'wmts',
		options: {
			url: 'https://{s}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}{r}.png',
		},
	},
	cartoDB_DarkMatter: {
		key: 'cartoDB_DarkMatter',
		thumbnail: 'cartoDB_DarkMatter',
		name: 'Dark',
		type: 'wmts',
		options: {
			url: 'https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}{r}.png',
		},
	},
	// esri_WorldGrayCanvas: {
	// 	key: 'esri_WorldGrayCanvas',
	// 	name: 'ESRI gray',
	// 	type: 'wmts',
	// 	options: {
	// 		url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
	// 		maxNativeZoom: 17,
	// 	},
	// },
	esri_WorldImagery: {
		key: 'esri_WorldImagery',
		name: 'ESRI aerial',
		type: 'wmts',
		options: {
			url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
			maxNativeZoom: 17,
		},
	},
	openStreetMap_Mapnik: {
		key: 'openStreetMap_Mapnik',
		name: 'OSM',
		type: 'wmts',
		options: {
			url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
		},
	},
	urbanAtlas: {
		key: 'urbanAtlas',
		name: 'Urban Atlas',
		type: 'wms',
		options: {
			url: 'https://ptr.gisat.cz/mapproxy/cure_production_UA_background/service',
			params: {
				layers: 'UAs_merged',
			},
		},
	},
};
